import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const BinIcon = ({ size = 16, color = 'currentFill' }: SystemIconType) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 18 17"
        fill={color}>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M5.75 1A.75.75 0 0 1 6.5.25h5a.75.75 0 0 1 .75.75v2.25h4.25a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1 0-1.5h4.25V1zm1.5 2.25h3.5v-1.5h-3.5v1.5zm-3.75 3a.75.75 0 0 1 .75.75v7c0 .69.56 1.25 1.25 1.25h7c.69 0 1.25-.56 1.25-1.25V7a.75.75 0 0 1 1.5 0v7a2.75 2.75 0 0 1-2.75 2.75h-7A2.75 2.75 0 0 1 2.75 14V7a.75.75 0 0 1 .75-.75z"/>
    </svg>
);
BinIcon.displayName = 'BinIcon';
export default BinIcon;
